import { css } from 'styled-components';
const MULTIPLIER = 4;
const positionMixin = Array.from({
  length: 15
}).map((_, index) => {
  const position = index + 1;
  const value = position * MULTIPLIER;
  return `
    .m-bottom-${position} {
      margin-bottom: ${value}px !important;
    }

    .m-top-${position} {
      margin-top: ${value}px !important;
    }

    .p-x-${position} {
      padding-left: ${value}px !important;
      padding-right: ${value}px !important;
    }

    .p-y-${position} {
      padding-bottom: ${value}px !important;
      padding-top: ${value}px !important;
    }
  `;
}).join('');
export const utilsCss = css(["", " .m-x-auto{margin-left:auto !important;margin-right:auto !important;}"], positionMixin);